module.exports = __webpack_public_path__ + "static/media/mini_games_gif.1b8f7d52.gif";